export type ActivationVia = 'pointer' | 'keyboard';
export type MarkerActivation = 'navigate' | 'select';

/**
 * What activating a site marker does. With hover, the tooltip already previewed the site,
 * so a click opens it. Without hover (touch), the first tap selects the site so the user
 * sees what they tapped before leaving the map. The keyboard always opens the site.
 */
export function markerActivation(canHover: boolean, via: ActivationVia): MarkerActivation {
  return via === 'keyboard' || canHover ? 'navigate' : 'select';
}
